import React from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CommonPieChart from "../pie-chart";
import BudgetInsights from "../right-sde-wrapper/BudgetInsights";
import CurrencySelectBox from "../right-sde-wrapper/CurrencySelectBox";
import ExpensesDetailsCardInner from "./ExpensesDetailsCardInner";

const ExpensesDetails = () => {
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  return (
    <>
      <div className="row mx-0 statics-details-row">
        {dashboardData?.totalExpense != 0 && (
          <div className="total-all-budgets-div position-relative">
            <div className="row mx-0">
              <div className="col-12 p-0">
                <CurrencySelectBox />
                <div className="summary-graph">
                  <CommonPieChart />
                </div>
                <div className="line-tag" />
                <BudgetInsights />
              </div>
            </div>
          </div>
        )}
        <div
          className={`total-all-sources ${
            dashboardData?.totalExpense == 0 ? "w-100" : ""
          }`}
        >
          <div className="row">
            <ExpensesDetailsCardInner />
          </div>
        </div>
      </div>
      {dashboardData?.totalExpense == 0 && (
        <div className="col-12 no-data-screen-db">
          <p>
            <Trans
              i18nKey="dashboard.noDataFound"
              components={{
                linkClick: (
                  <Link to={"/settings/edit-form/expenses"}>
                    <b></b>
                  </Link>
                ),
              }}
            />
          </p>
        </div>
      )}
    </>
  );
};

export default ExpensesDetails;
